import { Box, Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import {
  generateOptionId,
  getChipStyles,
  getGroupHeader,
  getOptionIcon,
} from '../StationFilterUtils';
import { StationFilterOption } from '../types';

export interface StationFilterChipProps {
  option: StationFilterOption;
  size?: 'small' | 'medium' | 'large';
  onDelete?: () => void;
  readonly?: boolean; // If true, don't show delete button
}

export const StationFilterChip = ({
  option,
  size = 'medium',
  onDelete,
  readonly = false,
}: StationFilterChipProps) => {
  const { $t } = useIntl();

  const sizeConfig = {
    small: {
      height: '28px',
      borderRadius: '14px',
      fontSize: '12px',
      iconSize: '14px',
    },
    medium: {
      height: '42px',
      borderRadius: '21px',
      fontSize: '16px',
      iconSize: '16px',
    },
    large: {
      height: '56px',
      borderRadius: '28px',
      fontSize: '18px',
      iconSize: '18px',
    },
  };

  const config = sizeConfig[size];

  return (
    <Chip
      key={generateOptionId(option)}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ color: '#555', mr: 0.5, fontSize: config.iconSize }}>
            {getOptionIcon(option.type)}
          </Box>
          <Box px={0.5}>
            <Box
              sx={{
                fontSize: size === 'small' ? '10px' : '11px',
                lineHeight: size === 'small' ? '12px' : '14px',
                color: '#999',
              }}
            >
              {getGroupHeader($t, option.type, 'short')}
            </Box>
            <Box
              sx={{
                fontSize: config.fontSize,
                lineHeight: config.fontSize,
                marginTop: '2px',
              }}
            >
              {option.label}
            </Box>
          </Box>
        </Box>
      }
      variant="outlined"
      onDelete={readonly ? undefined : onDelete}
      sx={{
        height: config.height,
        borderRadius: config.borderRadius,
        ...getChipStyles(option.type),
      }}
    />
  );
};
